import * as React from "react"
import {Container, Message} from "semantic-ui-react"
import {Article} from "./About"

// From comment under this answer https://stackoverflow.com/a/17907562/3509004
function isIE() {
  return (
    navigator.appName === "Microsoft Internet Explorer" ||
    (navigator.appName === "Netscape" &&
      new RegExp("Trident/.*rv:([0-9]+[.0-9]*)").exec(navigator.userAgent) != null)
  )
}

export function unsupportedBrowser() {
  return isIE()
}

export function Unsupported() {
  return (
    <Article>
      <Message warning>
        <p>
          Welcome to the new C U Soon booking site. Unfortunately it seems you are using an older
          browser that we do not support.
        </p>
        <p>
          Please try a recent version of Chrome, Safari or Firefox or just use your smart phone or
          tablet.
        </p>
        <p>Or call us directly on 1300 C U Soon (1300 287 666) or 0448 287 666 to make a booking.</p>
      </Message>
    </Article>
  )
}



// WEBPACK FOOTER //
// ./src/components/Unsupported.tsx